// Mirror reactif Svelte 5 de la locale Paraglide courante. Utilite : Paraglide expose
// `getLocale()` qui est une fonction PURE (pas un $state), donc Svelte ne sait pas qu'il faut
// re-render quand son resultat change. Le pattern habituel est le {#key currentLocale} sur la
// page DOM (qui re-mount le subtree au switch), mais ca ne marche pas pour les composants
// Threlte dans le <Canvas> que l'on a deliberement sortis du {#key} (cf [map]/+page.svelte
// — eviter la ré-init WebGL au switch de langue).
//
// Solution : un singleton `$state` mis a jour explicitement depuis afterNavigate du layout
// root. Les composants 3D qui ont besoin de re-peindre une texture canvas au switch de
// langue (RobotUnlockButton, futures labels i18n...) lisent `localeStore.current` dans un
// $effect → re-trigger automatique.

import { getLocale, type Locale } from '$lib/paraglide/runtime';

function createLocaleStore() {
  // Initialise avec la locale courante au module-load. afterNavigate du layout root la
  // synchronise apres chaque navigation (donc apres chaque switch de langue, qui declenche
  // un goto interne via LanguageSwitcher).
  let current = $state<Locale>(getLocale());

  return {
    get current() {
      return current;
    },
    /** A appeler depuis afterNavigate du layout root. Idempotent (re-set la meme valeur ne
     *  re-trigger pas les consumers grace au value-equality de $state). */
    sync() {
      const next = getLocale();
      if (next !== current) current = next;
    }
  };
}

export const localeStore = createLocaleStore();
